import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TeamDiscovery from './TeamDiscovery';

const TeamDiscoveryPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();

  if (!eventId) {
    return (
      <div>
        <div style={{ marginBottom: '20px' }}>
          <button onClick={() => navigate('/events')} className="btn btn-secondary">
            ← Back to Events
          </button>
        </div>
        <div className="error-container">
          <h2>❌ Missing Event ID</h2>
          <p>Unable to load team discovery without an event ID.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <button onClick={() => navigate(`/events/${eventId}`)} className="btn btn-secondary">
          ← Back to Event
        </button>
      </div>
      <div>
        <h1>🔍 Find Team Members</h1>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          Discover other participants who haven't joined a team yet and might be a good fit for your project.
        </p>
        <TeamDiscovery eventId={eventId} />
      </div>
    </div>
  );
};

export default TeamDiscoveryPage;
